module.exports = __webpack_public_path__ + "img/p6.9fe46e65.jpg";